/* unplugin-vue-components disabled */import script from "./InAppFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./InAppFrame.vue?vue&type=script&setup=true&lang=js"

import "./InAppFrame.vue?vue&type=style&index=0&id=02619f12&lang=less"

const __exports__ = script;

export default __exports__